import React from 'react';

const LogTable = ({ headers, logs }) => {
  return (
    <table>
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {logs.map((log, index) => (
          <tr key={index}>
            <td>{log.log_text}</td>
            <td>{log.log_created}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default LogTable;